import { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import DeployCompany from './deployCompany';

class ViewDeployCompany extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get Company',
                content: <GetInfo apiLink='companies/getOneCompany/' isNonDeployedCompanies={true}/>,
                id: 0,
            }, {
                title: 'Deploy Company',
                content: <DeployCompany />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewDeployCompany
